var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRiskManagementMenu = function SvgRiskManagementMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#risk-management-menu_svg__a)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.309,
    cy: 5.849,
    fill: "url(#risk-management-menu_svg__b)",
    rx: 5.935,
    ry: 5.849
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B35DFF",
    d: "M18.6 18.926c.006-.087.018-.175.018-.263-.006-2.035-.362-4.03-1.05-5.808-.576-1.491-1.365-2.778-2.315-3.79a5.95 5.95 0 0 1-4.944 2.615 5.95 5.95 0 0 1-4.944-2.615c-.943 1.012-1.739 2.299-2.314 3.79-.689 1.778-1.045 3.773-1.051 5.808 0 .088.012.176.018.263z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 10.156,
    height: 8.309,
    x: 22.654,
    y: 13.928,
    fill: "url(#risk-management-menu_svg__c)",
    rx: 0.95,
    transform: "rotate(90 22.654 13.928)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "risk-management-menu_svg__b",
    x1: 10.321,
    x2: 10.321,
    y1: 0,
    y2: 11.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7CC6",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "risk-management-menu_svg__c",
    x1: 32.783,
    x2: 22.654,
    y1: 22.237,
    y2: 22.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5A6D2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "risk-management-menu_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgRiskManagementMenu;